var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail-page',{attrs:{"breadcrumb":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_c('div',[_vm._v("找不到指定内容(╥╯^╰╥)")]),_c('div',[_c('span',{on:{"click":_vm.back}},[_vm._v("返回主页")])])])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }